/**
 * KnowledgeBase Constants - Configuration and styling constants
 * 
 * PROJECT_RULES.md Compliance:
 * - ✅ Consistent design language
 */

import type { CategoryColors } from './types';

export const CATEGORY_COLORS: CategoryColors = {
  recipes: '#E07A55',
  'meal-planning': '#6E9C87',
  'shopping-list': '#3C6E71',
  account: '#D98E73',
  support: '#6A4C93'
};

export const DEFAULT_COLOR = '#4A6651';

export const BACKGROUND_COLORS = {
  loading: '#73463e',
  error: '#E6EFEA',
  main: '#E6EFEA'
};